// @flow

import React from 'react';
import Slider from '../../components/Slider';
import Media from '../world/media/Media';
import SliderElement from '../../components/SliderElement';
import {
  WORLD_EVENTS,
  WORLD_GROUP_OVERVIEW,
  WORLD_INVESTORS,
  WORLD_MAP,
  WORLD_MARKETING,
  WORLD_MEDIA,
} from '../../path/worldPaths';
import GenericMapContainer from '../common/GenericMapContainer';
import WorldMap from '../world/map/WorldMap';
import Marketing from '../world/data/Marketing';
import EventPage from '../world/data/EventsPage';
import GroupOverviewEmbeddedUrl from '../world/data/GroupOverviewEmbeddedUrl';
import FinanceInvestorsEmbeddedUrl from '../world/data/FinanceInvestorsEmbeddedUrl';

type Props = {}

type State = {
  currentSlideIndex: number,
}

class WorldBase extends React.Component<Props, State> {
  state: State = {
    currentSlideIndex: 0,
  };

  render() {
    return (
      <div className="slider-container">
        <Slider
          goTopOnUpdate
          updateCurrentSlide={selectedIndex =>
            this.setState({ currentSlideIndex: selectedIndex })
          }
          selectedIndex={this.state.currentSlideIndex}
        >
          <SliderElement path={WORLD_MAP} render={<GenericMapContainer map={<WorldMap />} />} />
          <SliderElement path={WORLD_GROUP_OVERVIEW} render={<GroupOverviewEmbeddedUrl />} />
          <SliderElement path={WORLD_INVESTORS} render={<FinanceInvestorsEmbeddedUrl />} />
          {/*<SliderElement path={WORLD_MARKETING} render={<Marketing />} />*/}
          <SliderElement isLazy path={WORLD_EVENTS} render={<EventPage />} />
          <SliderElement path={WORLD_MEDIA} render={<Media />} />
        </Slider>
      </div>
    );
  }
}

export default WorldBase;
